import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { MapPinIcon, Share2Icon } from "lucide-react";
import { avataresClientes, business, pilares } from "../data/business";
const EASE = [0.23, 1, 0.32, 1] as const;
interface HeroProps {
  onCompartilhar: () => void;
}
export function Hero({
  onCompartilhar
}: HeroProps) {
  const reduzirMovimento = useReducedMotion();
  const entrada = (delay: number) => reduzirMovimento ? {} : {
    initial: {
      opacity: 0,
      y: 14
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.3,
      ease: EASE,
      delay
    }
  };
  return <header className="relative" data-id="element-63" data-mp="s9q8brns6vfz">
      <div className="relative h-[380px] w-full overflow-hidden" data-id="element-64" data-mp="nc894szkful6">
        <motion.img src={business.capa} alt={`${business.profissional}, ${business.especialidade}, em seu consultório`} initial={reduzirMovimento ? undefined : {
        opacity: 0,
        scale: 1.24
      }} animate={reduzirMovimento ? undefined : {
        opacity: 1,
        scale: 1.2
      }} transition={{
        duration: 0.3,
        ease: EASE
      }} className="h-full w-full scale-[1.2] object-cover object-[64%_22%]" data-id="element-65" data-mp="nbygsyr1tbcb" />
        <div className="absolute inset-0 bg-ink/20" aria-hidden="true" data-id="element-66" data-mp="39acx8ne15ksh" />
        <motion.div {...entrada(0.08)} className="absolute inset-x-0 top-0 flex items-center justify-between px-4 pt-6" data-id="element-67" data-mp="39cflp2zjb5v3">
          <span className="flex h-10 w-[172px] items-center justify-center overflow-hidden rounded-xl bg-cream/90 px-2" data-id="element-68" data-mp="30i19xae7qdgq">
            <img src={business.logoHorizontal} alt={`${business.nome} — ${business.especialidade}`} className="h-full w-full scale-[1.45] object-cover" data-id="element-69" data-mp="3599k48nda2uy" />
          </span>
          <button type="button" onClick={onCompartilhar} aria-label="Compartilhar esta página" className="flex h-10 w-10 items-center justify-center rounded-xl bg-cream/90 text-ink transition-colors duration-150 ease-out hover:bg-cream active:bg-sand focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cream" data-id="element-70" data-mp="2qi0o9hsvfl9d">
            <Share2Icon className="h-[18px] w-[18px] text-mocha" strokeWidth={1.6} data-id="element-71" data-mp="s2tb5evynxmk" />
          </button>
        </motion.div>
      </div>

      <div className="relative -mt-10 rounded-t-[32px] bg-cream px-4 pt-8" data-id="element-72" data-mp="n9i2r9bi38sj">
        <motion.h1 {...entrada(0.1)} className="font-display text-[38px] leading-[1.05] text-ink" data-id="element-73" data-mp="ichyn3y7og42">
          {business.profissional}
        </motion.h1>
        <motion.p {...entrada(0.13)} className="eyebrow mt-2 text-[10px] font-medium text-mocha" data-id="element-74" data-mp="1b1ffd2mry4up">
          {business.especialidade}
        </motion.p>
        <motion.p {...entrada(0.16)} className="mt-3 text-[15px] leading-relaxed text-muted" data-id="element-75" data-mp="162m3tfr1snx6">
          {business.bio}
        </motion.p>

        <motion.ul {...entrada(0.19)} className="mt-4 flex flex-wrap gap-1.5" data-id="element-76" data-mp="x1ec5gj1elc2">
          {pilares.flatMap(pilar => pilar.titulo.split('·').map(termo => ({
          id: `${pilar.id}-${termo}`,
          termo: termo.trim()
        }))).map(item => <li key={item.id} className="rounded-full bg-sand px-2.5 py-1 text-[11px] font-medium text-mocha-dark" data-id="element-77" data-mp="1x9b6f48dr7e5">
                {item.termo}
              </li>)}
        </motion.ul>

        <motion.div {...entrada(0.22)} className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-2 text-[12.5px] text-muted" style={{
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "normal"
      }} data-id="element-78" data-mp="2697m4gcskvx2">
          <span className="flex items-center gap-1.5" data-id="element-79" data-mp="2g2584wgzt30f">
            <MapPinIcon className="h-4 w-4 text-mocha" strokeWidth={1.6} data-id="element-80" data-mp="2kxu8h20u6nxs" />
            {business.cidade}
          </span>
          <span className="flex items-center gap-2.5" data-id="element-81" data-mp="2p1a6a1on6uc2">
            <span className="flex items-center" aria-hidden="true" data-id="element-82" data-mp="2u03ilqs70fan">
              {avataresClientes.map((cliente, indice) => <img key={cliente.id} src={cliente.imagem} alt="" className={`h-7 w-7 rounded-full border-2 border-cream object-cover ${indice > 0 ? '-ml-2.5' : ''}`} style={{
              width: "32px",
              height: "32px"
            }} data-id="element-83" data-mp="unj0xedciwmf" data-mpi={indice} />)}
            </span>
            {business.atendimentos}
          </span>
        </motion.div>
      </div>
    </header>;
}